<template>
    <v-app>
        <contact-form></contact-form>
        <v-content>
            <router-view/>
        </v-content>
        <v-footer class="blue darken-2">
            <v-layout row wrap align-center>
                <v-flex xs12 class="offset-xs1">
                    <span class="white--text">
                        Fait avec
                        <v-icon class="red--text">favorite</v-icon>
                        du jeu par Jinic-Media et Culture Jeux.
                    </span>
                </v-flex>
            </v-layout>
        </v-footer>
    </v-app>
</template>

<script>

    import ContactForm from "./components/ContactForm";

    export default {
        name: 'App',
        components: {
            ContactForm

        },
        data() {
            return {
                title: "Bomba-Nygma"
            }
        }
    }
</script>
<style>
</style>
